'use strict';

/* Стили */
import '../css/site.scss';

/* Библиотеки */
import { initAccordion } from './modules/accordion/init-accordion.js';

/* Скрипты */
import sliders from './modules/sliders.js/sliders';
import cases from './modules/cases';
import start_video from './modules/start-video';
import reviews from './modules/reviews';
import faq from './modules/faq.js';
import collapse from './modules/collapse.js';
import initBanner from './modules/init-banner.js';
import site from './modules/site.js';
import form from './modules/form/form.js';
import metrics from './modules/metrics.js';
import UtmTags from './modules/UtmTags.js';
import initFilters from './modules/init-filters.js';
import initTooltips from './modules/init-tooltips.js';
import {initModal} from './modules/modal/init-modal.js';
import renderStepsModal from './modules/modal/render-steps-modal.js';
import initTabs from './modules/init-tabs.js';
import initShowMoreButton from './modules/init-show-more-button.js';
import initChangeDate from './modules/date/index.js';
import geography from './modules/geography.js';
import initLeavePageModal from './modules/modal/init-leave-page-modal.js';
import initWidjet from './modules/init-widget.js';
import initCompleteModal from './modules/modal/init-complete-modal.js';
import initMoreButton from './modules/init-more-button.js';
import initQuizVideo from './modules/init-quiz-video.js';
import initGraduateVideo from './modules/init-graduate-video.js';
import renderParticipationModal from './modules/modal/render-participation-modal.js';
import 'lazysizes';
import '../lib/ls.video-vk-rutube-embed';
import { advcakeScriptFromPage } from './modules/advcake.js';

document.addEventListener('DOMContentLoaded', () => {
    advcakeScriptFromPage();
    initChangeDate();
    UtmTags();
    metrics();
    initBanner();
    collapse();
    initAccordion();
    //initFilters();
    renderParticipationModal();
    initTooltips();
    initCompleteModal();
    site();
    start_video();
    reviews();
    faq();
    sliders();
    cases();
    form();
    initModal();
    renderStepsModal();
    initLeavePageModal();
    initTabs();
    // initShowMoreButton('.products', 4);
    geography();
    initWidjet();
    initQuizVideo();
    initGraduateVideo();

    // Comments
    if (window.innerWidth <= 750) {
        initMoreButton();
    }
});
